import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import Icon from 'components/icon';
import parse from 'html-react-parser';

export default function ElectiveListing({ item }) {
    return (
        <div className={`c-elective-listing ${item.videoId && 'has-video'}`}>

            {item.thumbnail && (
                <div className="tile-image-wrapper">
                    <img src={item.thumbnail} alt={item.title} />
                </div>
            )}

            {item.videoId && (
                <div className="c-video-embed">
                    {item.videoHost === 'youtube' && (
                        <iframe
                            title={item.title}
                            data-lazy={true}
                            src={`https://www.youtube.com/embed/${item.videoId}?
                                rel=0&showinfo=0&color=white&autoplay=1&mute=1&loop=1&playlist=${item.videoId}`}
                            width="640"
                            height="360"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{ border: '0' }}
                        />
                    )}

                    {item.videoHost === 'vimeo' && (
                        <iframe
                            title={item.title}
                            data-lazy={true}
                            src={`https://player.vimeo.com/video/${item.videoId}?autoplay=1&muted=1&loop=1`}
                            width="640"
                            height="360"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{ border: '0' }}
                        />
                    )}
                </div>
            )}

            <div className="tile-content-wrapper">
                <div className="tile-title">
                    <h4>{item.title}</h4>

                    {item.subtitle && (
                        <span className="tile-subtitle">{item.subtitle}</span>
                    )}
                </div>

                <div className="tile-content" dangerouslySetInnerHTML={{ __html: item.paragraph }} />

                <div className="tile-tag-link-holder">
                    <a href={item.tagUrl} className="tile-tag-link">
                        <Icon glyph="tag" />
                        <span>{parse(item.tagText)}</span>
                    </a>
                </div>

                {item.buttons.length > 0 && (
                    <div className="tile-links">
                        {item.buttons.map((button, index) =>
                            ((button.btnUrl && button.btnText) && (
                                <a key={`button_${index}`} href={button.btnUrl} className={button.btnClass} >
                                    {button.btnText}
                                </a>
                            )))}
                    </div>
                )}
            </div>
        </div>
    );
}

ElectiveListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        title: string.isRequired,
        subtitle: string,
        thumbnail: string,
        videoHost: string,
        videoId: string,
        paragraph: string.isRequired,
        tagUrl: string.isRequired,
        tagText: string.isRequired,
        buttons: arrayOf(shape({
            btnText: string,
            btnUrl: string,
            btnClass: string
        }))
    }).isRequired
    /* eslint-enable react/no-typos */
};
